// Помощники вкладок «Вес» и «Замеры»: ошибки полей из ApiError, сброс кэша метрик.

import { useQueryClient } from '@tanstack/react-query'

import { ApiError } from '@/api/client'
import { metricKeys } from '@/pages/metrics/api'

export const SOURCE_LABELS: Record<string, string> = {
  manual: 'вручную',
  zepp: 'Zepp Life',
  csv: 'CSV',
  garmin: 'Garmin',
  mcp: 'MCP',
  ai: 'ИИ',
}

/** Ошибка API у конкретного поля (правило 7: error.field). */
export function fieldError(error: unknown, field: string): string | null {
  return error instanceof ApiError && error.field === field ? error.message : null
}

/** Ошибка API, не привязанная ни к одному из полей формы. */
export function formError(error: unknown, fields: string[]): unknown {
  if (error instanceof ApiError && error.field && fields.includes(error.field)) return null
  return error
}

export function useInvalidateMetrics() {
  const client = useQueryClient()
  return () => client.invalidateQueries({ queryKey: metricKeys.all })
}
